import Translation from '../../state/state-types/TranslationStateType'

export const isValidPhone = (phone: string) => {
    if (/[^0-9\s\-+()]/.test(phone)) return false
    const digitsOnly = phone.replace(/\D/g, '')
    return digitsOnly.length >= 4 && digitsOnly.length <= 15
}

export const checkPhone = (phone: string, translation: Translation) => {
    if (!isValidPhone(phone)) {
        return translation.validation.notAValidPhoneNumber
    } else {
        return ''
    }
}
